import React, { useEffect, useRef } from 'react';

const HilltopBanner = ({ settings = {} }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // 1. Create the script
    const s = document.createElement('script');
    s.settings = settings;
    s.src = "//experienced-stupid.com/beX.VzssdFG/lR0aYbWoct/Le/mA9xuvZWUAlqkRP/TmY/3sNDz/Mn1MNQD/EttSN_jzc_3dM/ziUM0FN_Qy";
    s.async = true;
    s.referrerPolicy = 'no-referrer-when-downgrade';

    // 2. Insert it EXACTLY inside this component's div
    containerRef.current.appendChild(s);

    // 3. Cleanup
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = ''; // Clear the script and any injected ads
      }
    };
  }, [settings]);

  // We return a div so the ad has a place to live in your layout
  return <div ref={containerRef} className="hilltop-banner-container" />;
};

export default HilltopBanner;
